import '@code-dot-org/component-library/carousel/index.css';

// Export the Component Definition for use in Contentful Studio
export {ImageCarouselContentfulComponentDefinition} from './imageCarouselContentfulDefinition';
export {default} from './ImageCarousel';
